export default __webpack_public_path__ + "static/media/bolognese.721d5ea1.jpg";